import React, { useState } from 'react';

const ArticleImages = () => {
  const [style, setStyle] = useState({}); // Store dynamic styles

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const { left, top, width, height } = card.getBoundingClientRect();
  
    // Calculate mouse position relative to the card
    const x = e.clientX - left; // Mouse X position inside the card
    const y = e.clientY - top;  // Mouse Y position inside the card
  
    // Calculate center of the card
    const centerX = width / 2;
    const centerY = height / 2;
  
    // Calculate tilt values
    const rotateY = ((x - centerX) / centerX) * 20; // Left/right tilt
    const rotateX = ((centerY - y) / centerY) * 20; // Up/down tilt
  
    // Update the style for transform
    setStyle({
      transform: `scale(1.05) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
      transition: 'transform 0.1s linear', // Smooth tilt
    });
  };
  
  const handleMouseLeave = () => {
    setStyle({
      transform: 'rotateX(0deg) rotateY(0deg)', // Reset to default
      transition: 'transform 0.3s ease-out', // Smooth transition
    });
  };

  return (
    <div
    style={style} // Apply dynamic styles
    onMouseMove={handleMouseMove}
    onMouseLeave={handleMouseLeave}>
    <img  alt='article images' className='article-images' src={require('./PHOTOS.png')}/>
    </div>
  );
};

export default ArticleImages;
